<template>
    <div class="woocommerce-product-gallery-load">
        <section class="sk-home__section sk-home__section--skeleton sk-home__gallery--skeleton">
            <div class="sk-home__container">
                <div class="delivery-care__items">
                </div>
            </div>
        </section>
    </div>
</template>

<style scoped lang="scss">
    @import "@/assets/scss/components/product/_gallery.scss";
</style>